/**
 * SahiCart — Product Card Add to Cart Alignment Fix
 * ---------------------------------------------------
 * Problem: Product cards have variable content height (1-line vs 2-line
 * titles, with/without reviews, etc.), so the Add to Cart button lands
 * at different vertical positions across cards in the same row.
 *
 * Why plain CSS (margin-top: auto on last-child) didn't work:
 * The Add to Cart button is nested inside an intermediate wrapper
 * (Horizon theme's block/quick-add structure), so a simple
 * ">  *:last-child" selector can't reach the right element.
 *
 * Fix: Walk up from the actual button to find its DIRECT child of the
 * card's flex container (.product-card__content), then push THAT
 * element to the bottom using margin-top: auto.
 *
 * Safe to remove: delete this file + the one <script> line in
 * theme.liquid that loads it. Nothing else is touched.
 */

(function () {
  'use strict';

  function alignCardButtons() {
    // Every product card wrapper on the page
    const cards = document.querySelectorAll('.product-card__content');

    cards.forEach((cardContent) => {
      // Find the Add to Cart button inside this specific card
      const button = cardContent.querySelector(
        '[data-testid="standalone-add-to-cart"], .add-to-cart-button'
      );

      if (!button) return; // no button in this card (e.g. sold out state), skip

      // Walk up from the button until we find the element that is a
      // DIRECT child of .product-card__content — that's the real
      // "row" we need to push to the bottom.
      let target = button;
      while (target.parentElement && target.parentElement !== cardContent) {
        target = target.parentElement;
      }

      if (target && target.parentElement === cardContent) {
        target.style.marginTop = 'auto';
      }
    });
  }

  // Run once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', alignCardButtons);
  } else {
    alignCardButtons();
  }

  // Re-run when new cards are added (infinite scroll / filter changes /
  // quick-add re-renders) — Horizon theme uses custom elements + fetch
  // to inject new cards without a full page reload.
  const observer = new MutationObserver(() => {
    alignCardButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();